import { Counter } from './features/counter/Counter';
import './App.css';
import '../src/assets/style.css'
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import StoresListContainer from './features/stores/list/StoresListContainer';
import LoginContainer from './features/login/LoginContainer';
import { AuthProvider } from './utils/authorization';
import StoreManagementContainer from './features/stores/management/StoreManagementContainer';
import StoreCreationContainer from './features/stores/management/creation/StoreCreationContainer';
import StoreCustomizationContainer from './features/customization/StoreCustomizationContainer';
import ProtectedRoute from './features/auth/ProtectedRoute';
import UnauthorizedPage from './features/auth/UnauthorizedPage';
import ErrorPage from './features/error/ErrorPage';
import SignInCodeErrorPage from './features/error/SignInCodeExpiredPage';
import AdminUsersContainer from './features/admin-manager/Index';
import CarouselSlideEditorContainer from './features/customization/carousel/SlideEditor/CarouselSlideEditorContainer';
import GlobalActivityContainer from './features/logs/GlobalActivityContainer';

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path='/login' element={<LoginContainer />} />
            <Route element={<ProtectedRoute />}>
              <Route path='/' element={<StoresListContainer />} />
              <Route path='/stores' element={<StoresListContainer />} />
              <Route path='/counter' element={<Counter />} />
              <Route path='/report/:storeId' element={<ReportRedirect />} />
              <Route path='/management/:storeId' element={<StoreManagementContainer />} />
              <Route path="/management/:storeId/customization/carousel/new" element={<CarouselSlideEditorContainer />} />
              <Route path="/management/:storeId/customization/carousel/:slideIndex" element={<CarouselSlideEditorContainer />} />
            </Route>
            <Route element={<ProtectedRoute requiredScopes={['stores:create']} />}>
              <Route path='/create' element={<StoreCreationContainer />} />
            </Route>
            <Route element={<ProtectedRoute requiredScopes={['admin:users:manage']} />}>
              <Route path="/admin/users" element={<AdminUsersContainer />} />
            </Route>
            <Route element={<ProtectedRoute requiredScopes={['logs:view']} />}>
              <Route path="/admin/activity" element={<GlobalActivityContainer />} />
            </Route>
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path="*" element={<ErrorPage />} />
            <Route path="/error/sign-in-code" element={<SignInCodeErrorPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  )
}

function ReportRedirect() {
  const { storeId } = useParams<{ storeId: string }>();
  return <Navigate to={`/management/${storeId}?tab=report`} replace />;
}

export default App;
